export default __webpack_public_path__ + "static/media/todo_book.239fbdb9.png";